/* Part picker sheet: a bottom sheet on phones, a centred dialog elsewhere. */
.sheet {
  padding: var(--tuna-spacing-3);
}

@media (max-width: 599.95px) {
  .sheet {
    margin-top: auto;
    margin-bottom: 0;
    width: 100%;
    max-width: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.title {
  margin: 0 0 var(--tuna-spacing-0_5);
  font-size: var(--tuna-typography-h6-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
}

.hint {
  margin: 0 0 var(--tuna-spacing-2);
  color: var(--tuna-palette-text-secondary);
}

.parts {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
  gap: var(--tuna-spacing-1);
  margin-bottom: var(--tuna-spacing-2);
}

/* Touch targets of at least 44px */
.part {
  min-height: var(--tuna-spacing-6);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--tuna-spacing-1);
  margin-top: var(--tuna-spacing-2);
}

/* "Pick all that apply" under the part menu title */
.menuHint {
  padding: 0 var(--tuna-spacing-2) var(--tuna-spacing-0_5);
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

/* Part menu items: touch targets of at least 44px in Perform */
.menuItem {
  min-height: var(--tuna-spacing-6);
}

/* The header trigger stays on one line: a two-line control in a one-line header reads as broken */
.trigger {
  white-space: nowrap;
}

@media (max-width: 1535.95px) {
  .playingWordOptional {
    display: none;
  }
}
